export const n = (v) => {
  const x = Number(v);
  return Number.isFinite(x) ? x : 0;
};

export function fmtRp(v, opts = {}) {
  const { decimals = 0, dash = false } = opts;
  const x = Number(v);
  if (!Number.isFinite(x)) return dash ? "–" : "Rp 0";
  const abs = Math.abs(x).toLocaleString("id-ID", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return `${x < 0 ? "-" : ""}Rp ${abs}`;
}

export function fmtRpShort(v) {
  const x = n(v);
  const a = Math.abs(x);
  const s = x < 0 ? "-" : "";
  if (a >= 1e12) return `${s}Rp ${(a / 1e12).toLocaleString("id-ID", { maximumFractionDigits: 2 })} T`;
  if (a >= 1e9) return `${s}Rp ${(a / 1e9).toLocaleString("id-ID", { maximumFractionDigits: 2 })} M`;
  if (a >= 1e6) return `${s}Rp ${(a / 1e6).toLocaleString("id-ID", { maximumFractionDigits: 1 })} jt`;
  if (a >= 1e3) return `${s}Rp ${(a / 1e3).toLocaleString("id-ID", { maximumFractionDigits: 0 })} rb`;
  return `${s}Rp ${a.toLocaleString("id-ID")}`;
}

export function fmtNum(v, d = 0) {
  const x = Number(v);
  if (!Number.isFinite(x)) return "–";
  return x.toLocaleString("id-ID", { maximumFractionDigits: d, minimumFractionDigits: 0 });
}

export function fmtPct(v, d = 2) {
  const x = Number(v);
  if (!Number.isFinite(x)) return "–";
  return `${x.toLocaleString("id-ID", { maximumFractionDigits: d })}%`;
}

export function fmtDate(iso) {
  if (!iso) return "–";
  try {
    return new Date(iso).toLocaleString("id-ID", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch (_) {
    return iso;
  }
}

export function fmtMonth(key) {
  if (!key) return "";
  const [y, m] = key.split("-").map(Number);
  return new Date(y, m - 1, 1).toLocaleString("id-ID", { month: "short", year: "numeric" });
}

export const uid = () => Math.random().toString(36).slice(2, 10);

export const MONTHS_ID = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];

export function deepMerge(base, extra) {
  if (Array.isArray(base) || Array.isArray(extra)) return extra !== undefined ? extra : base;
  if (typeof base !== "object" || base === null) return extra !== undefined ? extra : base;
  const out = { ...base };
  if (extra && typeof extra === "object") {
    for (const k of Object.keys(extra)) {
      out[k] = k in base ? deepMerge(base[k], extra[k]) : extra[k];
    }
  }
  return out;
}

export function downloadCsv(filename, rows) {
  const csv = rows
    .map((r) => r.map((c) => `"${String(c ?? "").replace(/"/g, '""')}"`).join(","))
    .join("\n");
  const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export const TOOL_META = {
  pajak: { label: "Kalkulator Pajak", short: "Pajak", path: "/tools/pajak" },
  hosting: { label: "COGS Hosting/VPS", short: "Hosting", path: "/tools/hosting" },
  isp: { label: "COGS Jaringan ISP", short: "ISP", path: "/tools/isp" },
  ekualizer: { label: "Ekualizer Pajak", short: "Ekualizer", path: "/tools/ekualizer" },
  kartu_kredit: { label: "Tagihan Kartu Kredit", short: "Kartu Kredit", path: "/tools/kartu-kredit" },
  meeting: { label: "Meeting Eddy", short: "Meeting", path: "/tools/meeting" },
  admin_test: { label: "Tes Admin", short: "Tes", path: "/admin" },
};
